module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Movie-lane1-506c1632dd7815db49deae0b63649abe.svg";